import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ImpressionEtiquetteTemplateComponent } from './impression-etiquette-template/impression-etiquette-template.component';

@Component({
  selector: 'app-datamatrix',
  templateUrl: './impression-etiquette.component.html',
  styleUrls: ['./impression-etiquette.component.css']
})
export class ImpressionEtiquetteComponent implements OnInit {
  id = 3456565;
  label = "Label test";
  type = "EXEMPLE_TYPE";

  constructor(public dialog: MatDialog) { }

  ngOnInit(): void {}

  impressionEtiquettes(e): void{
    const dialogRef = this.dialog.open(ImpressionEtiquetteTemplateComponent, {
      data : {id: this.id, label: this.label, type: this.type}
    });

    dialogRef.afterClosed().subscribe( res => {
      console.log("res: ", res);
    })
  }
}
